import 'classnames';
import 'emotion';
import { css } from '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import { _ as _objectSpread2, a as _taggedTemplateLiteralLoose } from '../chunk-1b90139e.js';
import './omit.js';
import { getColorFromCSSVariable } from '../ColorMode/utils.js';
import './pick.js';
import './cssProps.js';
import 'lodash/kebabCase';
import tinycolor from 'tinycolor2';
import { isFunction } from './isFunction.js';
import { get } from './get.js';
import { getCSSFromStyleObject } from './getCSSFromStyleObject.js';

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n      @media screen and (", ": ", "px) {\n        ", ";\n      }\n      @media screen and (", ": ", "px) {\n        ", ";\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        @media screen and (min-width: ", "px) and (max-width: ", "px) {\n          ", ";\n        }\n\n        @media screen and (max-width: ", "px) {\n          ", ";\n        }\n        @media screen and (min-width: ", "px) {\n          ", ";\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n          @media screen and (max-width: ", "px) {\n            ", ";\n          }\n          @media screen and (min-width: ", "px) {\n            ", ";\n          }\n\n          @media screen and (min-width: ", "px) and (max-width: ", "px) {\n            ", ";\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        ", ";\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function theme(themeKey, path, defaultValue) {
  return function (props) {
    var colorMode = props.colorMode,
        variant = props.variant;
    var selector = "" + themeKey + (path ? "." + path : '');
    var variantSelector = themeKey + ".variants." + variant + "." + path;
    var colorModeSelector = themeKey + ".modes." + colorMode + "." + path;
    var defaultTheme = get(props, "theme." + selector) || defaultValue;
    var variantTheme = get(props, "theme." + variantSelector);
    var colorModeTheme = get(props, "theme." + colorModeSelector);
    var defaultThemeOverrides;
    var variantThemeOverrides;
    var colorModeThemeOverrides;

    if (props.overrides) {
      defaultThemeOverrides = get(props, "overrides." + selector);
      variantThemeOverrides = get(props, "overrides." + variantSelector);
      colorModeThemeOverrides = get(props, "overrides." + colorModeSelector);
    }

    if (path && path.includes('styles')) {
      var defaultThemeValue = isFunction(defaultTheme) ? defaultTheme(props) : defaultTheme;
      var defaultThemeOverridesValue = isFunction(defaultThemeOverrides) ? defaultThemeOverrides(props) : defaultThemeOverrides;
      var variantThemeValue = isFunction(variantTheme) ? variantTheme(props) : variantTheme;
      var variantThemeOverridesValue = isFunction(variantThemeOverrides) ? variantThemeOverrides(props) : variantThemeOverrides;
      var colorModeThemeValue = isFunction(colorModeTheme) ? colorModeTheme(props) : colorModeTheme;
      var colorModeThemeOverridesValue = isFunction(colorModeThemeOverrides) ? colorModeThemeOverrides(props) : colorModeThemeOverrides;

      var styles = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, defaultThemeValue), defaultThemeOverridesValue), variantThemeValue), variantThemeOverridesValue), colorModeThemeValue), colorModeThemeOverridesValue);

      if (!styles.styles) {
        styles = getCSSFromStyleObject(styles, props.theme, colorMode);
      }

      return styles;
    }

    var theme = colorModeThemeOverrides || colorModeTheme || variantThemeOverrides || variantTheme || defaultThemeOverrides || defaultTheme;
    return isFunction(theme) ? theme(props) : theme;
  };
}

function altitude(selector, defaultValue) {
  return function (props) {
    var altitude = theme('altitudes', selector || props.altitude, defaultValue)(props);
    return altitude;
  };
}

function border(selector, defaultValue) {
  return function (props) {
    var border = theme('borders', selector || props.border, defaultValue)(props);
    return border;
  };
}

function borderRadius(selector, defaultValue) {
  return function (props) {
    var borderRadius = theme('borderRadii', selector || props.borderRadius, defaultValue)(props);
    return borderRadius;
  };
}

function font(selector, defaultValue) {
  return function (props) {
    var color = theme('fonts', selector || props.font, defaultValue)(props);
    return color;
  };
}

function fontMetric(selector) {
  return function (props) {
    var fontMetrics = theme('fontMetrics', selector || props.fontMetrics)(props);
    return fontMetrics;
  };
}

function fontSize(selector, defaultValue) {
  return function (props) {
    var color = theme('fontSizes', selector || props.fontSize, defaultValue)(props);
    return color;
  };
}

function fontWeight(selector, defaultValue) {
  return function (props) {
    var color = theme('fontWeights', selector || props.fontWeight, defaultValue)(props);
    return color;
  };
}

function lineHeight(selector, defaultValue) {
  return function (props) {
    var lineHeights = theme('lineHeights', selector || props.lineHeight, defaultValue)(props);
    return lineHeights;
  };
}

function letterSpacing(selector, defaultValue) {
  return function (props) {
    var letterSpacing = theme('letterSpacings', selector || props.letterSpacing, defaultValue)(props);
    return letterSpacing;
  };
}

function palette(_selector, modes, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$useCSSVariables = _ref.useCSSVariables,
      useCSSVariables = _ref$useCSSVariables === void 0 ? true : _ref$useCSSVariables;

  return function (props) {
    var _props$theme;

    var selector = modes && modes[props.colorMode] ? modes[props.colorMode] : _selector;
    var fallback = tinycolor(selector).toHexString();

    if (selector === 'transparent') {
      fallback = 'transparent';
    }

    if (((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.useCSSVariables) && useCSSVariables && !(selector === null || selector === void 0 ? void 0 : selector.includes('#'))) {
      return getColorFromCSSVariable(selector, fallback);
    }

    var color = theme('palette', selector || props.palette)(props);
    if (!color) return fallback;
    return color;
  };
}

function space(_scalar, _scaleType) {
  if (_scaleType === void 0) {
    _scaleType = 'minor';
  }

  return function (props) {
    var scalar = _scalar;
    var scaleType = _scaleType;
    if (!scalar) return 0;

    if (typeof scalar === 'string') {
      if (scalar.includes('minor') || scalar.includes('major')) {
        // @ts-ignore
        var _scalar$split = scalar.split('-');

        scaleType = _scalar$split[0];
        scalar = _scalar$split[1];
        scalar = parseFloat(scalar);
        if (isNaN(scalar)) return 0;
      } else {
        var value = theme('spacing', scalar)(props);
        return value;
      }
    }

    if (typeof scalar === 'number') {
      var _props$theme2, _props$theme2$spacing, _props$theme3, _props$theme3$global;

      var unitSize = props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$spacing = _props$theme2.spacing) === null || _props$theme2$spacing === void 0 ? void 0 : _props$theme2$spacing[scaleType + "Unit"];

      var _fontSize = props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : (_props$theme3$global = _props$theme3.global) === null || _props$theme3$global === void 0 ? void 0 : _props$theme3$global.fontSize;

      var _value = scalar * (unitSize / _fontSize);

      return _value;
    }
  };
}

function breakpoint(breakpoint, cssStyle, config) {
  var _ref2 = config || {},
      _ref2$else = _ref2.else,
      elseStyle = _ref2$else === void 0 ? '' : _ref2$else,
      _ref2$show = _ref2.show,
      show = _ref2$show === void 0 ? false : _ref2$show;

  return function (props) {
    var _props$theme4, _props$theme4$breakpo, _props$theme5, _props$theme5$breakpo, _props$theme6, _props$theme6$breakpo, _props$theme7, _props$theme7$breakpo, _props$theme8, _props$theme8$breakpo;

    if (!breakpoint) return css(_templateObject(), elseStyle);
    var key;
    var elseKey;

    if (!show && breakpoint.includes('max')) {
      key = 'max-width';
      elseKey = 'min-width';
    } else if (!show && breakpoint.includes('min')) {
      key = 'min-width';
      elseKey = 'max-width';
    } else if (show && breakpoint.includes('max')) {
      key = 'min-width';
      elseKey = 'max-width';
    } else if (show && breakpoint.includes('min')) {
      key = 'max-width';
      elseKey = 'min-width';
    }

    var strippedBreakpoint = breakpoint;
    strippedBreakpoint = strippedBreakpoint.replace('max-', '');
    strippedBreakpoint = strippedBreakpoint.replace('min-', '');
    var minBreakpointValues = {
      mobile: 0,
      tablet: props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : (_props$theme4$breakpo = _props$theme4.breakpoints) === null || _props$theme4$breakpo === void 0 ? void 0 : _props$theme4$breakpo.mobile,
      desktop: props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : (_props$theme5$breakpo = _props$theme5.breakpoints) === null || _props$theme5$breakpo === void 0 ? void 0 : _props$theme5$breakpo.tablet,
      widescreen: props === null || props === void 0 ? void 0 : (_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : (_props$theme6$breakpo = _props$theme6.breakpoints) === null || _props$theme6$breakpo === void 0 ? void 0 : _props$theme6$breakpo.desktop,
      fullHD: props === null || props === void 0 ? void 0 : (_props$theme7 = props.theme) === null || _props$theme7 === void 0 ? void 0 : (_props$theme7$breakpo = _props$theme7.breakpoints) === null || _props$theme7$breakpo === void 0 ? void 0 : _props$theme7$breakpo.widescreen
    };
    var breakpointValue = props === null || props === void 0 ? void 0 : (_props$theme8 = props.theme) === null || _props$theme8 === void 0 ? void 0 : (_props$theme8$breakpo = _props$theme8.breakpoints) === null || _props$theme8$breakpo === void 0 ? void 0 : _props$theme8$breakpo[strippedBreakpoint];

    if (!show && breakpoint.includes('max')) {
      breakpointValue = breakpointValue - 1;
    }

    if (!show && breakpoint.includes('min')) {
      breakpointValue = minBreakpointValues[strippedBreakpoint];
    }

    if (show && breakpoint.includes('min')) {
      breakpointValue = minBreakpointValues[strippedBreakpoint] - 1;
    }

    if (!breakpoint.includes('min-') && !breakpoint.includes('max-')) {
      if (show) {
        return css(_templateObject2(), minBreakpointValues[breakpoint], cssStyle, breakpointValue + 1, cssStyle, minBreakpointValues[breakpoint] + 1, breakpointValue, elseStyle);
      }

      return css(_templateObject3(), minBreakpointValues[breakpoint], breakpointValue - 1, cssStyle, minBreakpointValues[breakpoint] - 1, elseStyle, breakpointValue, elseStyle);
    }

    return css(_templateObject4(), key, breakpointValue, cssStyle, elseKey, breakpointValue, elseStyle);
  };
}

export { altitude, border, borderRadius, breakpoint, font, fontMetric, fontSize, fontWeight, letterSpacing, lineHeight, palette, space, theme };